























import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'

import Tags from '../../../Tags/Tags.vue'
import {
  Placeholder,
  PlaceholdersOnes as PlaceholdersOnesType,
  PlaceholdersStack as PlaceholdersStackType,
  PlaceholdersType
} from '../Toolbar/types'
import PlaceholdersStack from './PlaceholdersStack.vue'
import PlaceholderValueItem from './components/PlaceholderValueItem.vue'

@Component({
  components: {
    PlaceholderValueItem,
    Tags,
    PlaceholdersStack,
  },
  data() {
    return {
      PlaceholdersType,
    }
  }
})
export default class PlaceholdersList extends Vue {
  @Prop() placeholders!: PlaceholdersOnesType | PlaceholdersStackType

  @Prop() setPlaceholder!: (str: string) => void

  @PropSync('modalIsOpen') isOpen!: boolean

  insertPlaceholder(placeholder: Placeholder['value']): void {
    this.setPlaceholder(placeholder)
    this.isOpen = false
  }
}
